export * as ModuleActions from './actions';

export enum ModuleCodes {
  All = '*',
  Areas = 'Areas',
  Companies = 'Companies',
  Drivers = 'Drivers',
  DriverShifts = 'DriverShifts',
  ExtraServices = 'ExtraServices',
  Fares = 'Fares',
  FareGroups = 'FareGroups',
  Locations = 'Locations',
  Moderators = 'Users',
  Passengers = 'Passengers',
  Students = 'Students',
  Payments = 'Payments',
  Profiles = 'Profiles',
  Rates = 'Rates',
  Reservations = 'Reservations',
  Services = 'Services',
  Shifts = 'Shifts',
  Shuttles = 'Shuttles',
  Sites = 'Sites',
  Suppliers = 'Suppliers',
  Trips = 'Trips',
  Vehicles = 'Vehicles',
  Permissions = 'Permissions',
  Settings = 'Settings',
  Timeline = 'Timeline',
  Users = 'Users',
  Invitations = 'Invitations',
  ActiveDrivers = 'ActiveDrivers',
  Reports = 'Reports',
  RoiSimulation = 'RoiSimulation',
  LiveMap = 'LiveMap',
  OnlineDrivers = 'OnlineDrivers',
  Analytics = 'Analytics',
  History = 'History',
  DataUpload = 'DataUpload',
  Attributes = 'Attributes',
  Integrations = 'Integrations',
  BlacklistCards = 'BlacklistCards',
  Automations = 'Automations',
  Parents = 'Parents',
  Caregivers = 'Caregivers',
  CustomRules = 'CustomRules',
  Holidays = 'Holidays',
  MissionControl = 'MissionControl',
}
